import { useNavigate } from 'react-router-dom';

import InputField from 'components/fields/InputField';
import useForm from 'hooks/useForm';
import Card from 'components/card';
import Button from 'components/button';
import Header from 'components/text/header';
import UseApi from 'hooks/useApi';

export default function ChangePassword() {
  const navigate = useNavigate();

  const { postApi } = UseApi();

  const changePassword = async () => {
    if (newPassword !== confirmNewPassword) {
      alert('New passwords do not match');
      return;
    }

    const id = JSON.parse(localStorage.getItem('admin'))._id;
    const res = await postApi(`admins/${id}/change-password`, {
      oldPassword,
      newPassword,
      confirmNewPassword,
    });
    if (res.data.message === 'Password changed successfully') {
      resetForm();
    }
  };

  const { values, handleChange, resetForm, handleSubmit } = useForm(
    {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    changePassword,
  );
  const { oldPassword, newPassword, confirmNewPassword } = values;

  return (
    <Card extra=" p-4 ">
      {/* Old Password */}
      <Header extraClasses="mb-6">Change Password</Header>
      <InputField
        variant="auth"
        extra="mb-3"
        label="Old Password*"
        placeholder="****"
        id="oldPassword"
        type="password"
        value={oldPassword}
        onChange={handleChange}
        name="oldPassword"
      />

      {/* New Password */}
      <InputField
        variant="auth"
        extra="mb-3"
        label="New Password*"
        placeholder="****"
        id="newPassword"
        type="password"
        value={newPassword}
        onChange={handleChange}
        name="newPassword"
      />

      {/* Confirm New Password */}
      <InputField
        variant="auth"
        extra="mb-3"
        label="Confirm New Password*"
        placeholder="****"
        id="confirmNewPassword"
        type="password"
        value={confirmNewPassword}
        onChange={handleChange}
        name="confirmNewPassword"
      />

      <Button onClick={handleSubmit} extraClasses="m-auto">
        Change Password
      </Button>
    </Card>
  );
}
